import type { PlotInfo } from "../net/api";
import { hint } from "./touch";

const KEY = "nomen.estateSeen";

/** Banner text for a newly assigned estate, once per estate id (spec 2d §4.7); null when already shown. */
export function estateAnnouncement(plots: readonly PlotInfo[], myId: string | null,
  storage: Pick<Storage, "getItem" | "setItem"> | null): string | null {
  if (!myId) return null;
  const mine = plots.find((p) => p.kind === "estate" && p.owner_id === myId);
  if (!mine) return null;
  let seen: string | null = null;
  try { seen = storage?.getItem(KEY) ?? null; } catch { seen = null; }
  if (seen === mine.id) return null;
  try { storage?.setItem(KEY, mine.id); } catch { /* storage blocked: announce on every visit */ }
  return `你的領地在 ${mine.parcel_id ?? mine.id}，${hint("按 P 查看", "點 🗺 查看")}`;
}

export function safeStorage(): Storage | null {
  try { return window.localStorage; } catch { return null; }
}
